import { yellow, red, green, grey } from '@mui/material/colors';
import { AssessmentsScoreColorEnum } from '../features/globalTracker/types';

export const statusColors: [string, string, string, string] = [
  red[400],
  yellow[700],
  green[500],
  grey[300],
];

export const NOT_DEFINED_SCORE_VALUE = 3;

export const SCORE_TO_COLOR: {
  [key: number]: string;
} = {
  [AssessmentsScoreColorEnum.GREEN]: 'green',
  [AssessmentsScoreColorEnum.YELLOW]: 'yellow',
  [AssessmentsScoreColorEnum.RED]: 'red',
  [NOT_DEFINED_SCORE_VALUE]: 'No status provided',
};

export const LOOKER_REPORT =
  'https://lookerstudio.google.com/u/0/reporting/b470d9a8-c400-4147-8c71-16ad4375056e';
